<template>
    <div class="loading" v-show='loading'>
        <div class="load-content">
            <div class="c1"></div>
            <div class="c2"></div>
            <div class="c3"></div>
            <div class="c4"></div>
        </div>
        <span>loading...</span>
    </div>
</template>
<script>
    export default {
        name: 'HiLoading',
        props:['options'],
        data() {
            return {
                loading: true
            }
        }
    }
</script>
<style lang='scss' scoped>
    .loading {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.4);
        position: fixed;
        left: 0;
        top: 0;
    }

    .loading .load-content {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 50%;
        margin-left: 10px;
        top: 50%;
        margin-top: -20px;
    }

    .loading .load-content div {
        content: '';
        position: absolute;
        width: 5px;
        height: 5px;
        background: #ff8c00;
        top: 2px;
        left: 2px;
        transform-origin: 2px 2px;
        border-radius: 2px;
        /* animation: spin-a 1s infinite cubic-bezier(0.5, 0, 0.5, 1); */
    }
    .loading .load-content .c1 {
        top: 2px;
        left: 2px;
        transform-origin: 8px 8px;
        animation: spin-a 1.5s infinite cubic-bezier(0.5, 0, 0.5, 1);
    }
    .loading .load-content .c2 {
        top: 2px;
        left: auto;
        right: 2px;
        transform-origin: -8px 8px;
        animation: spin-b 1.5s infinite cubic-bezier(0.5, 0, 0.5, 1);
    }

    .loading .load-content .c3 {
        top: auto;
        left: auto;
        right: 2px;
        bottom: 1px;
        transform-origin: 8px -8px;
        animation: spin-c 1.5s infinite cubic-bezier(0.5, 0, 0.5, 1);
    }

    .loading .load-content .c4 {
        top: auto;
        bottom: 1px;
        transform-origin: 8px 8px;
        animation: spin-d 1.5s infinite cubic-bezier(0.5, 0, 0.5, 1);
    }

    @keyframes spin-a {
        0% {
            transform: rotate(90deg);
        }

        0% {
            transform: rotate(75deg);
        }

        50% {
            transform: rotate(165deg);
        }

        75% {
            transform: rotate(255deg);
        }

        100% {
            transform: rotate(345deg);
        }
    }

    @keyframes spin-b {
        0% {
            transform: rotate(90deg);
        }

        25% {
            transform: rotate(90deg);
        }

        25% {
            transform: rotate(180deg);
        }

        75% {
            transform: rotate(270deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes spin-c {
        0% {
            transform: rotate(90deg);
        }

        25% {
            transform: rotate(105deg);
        }

        50% {
            transform: rotate(195deg);
        }

        50% {
            transform: rotate(285deg);
        }

        100% {
            transform: rotate(15deg);
        }
    }

    @keyframes spin-d {
        0% {
            transform: rotate(90deg);
        }

        25% {
            transform: rotate(120deg);
        }

        50% {
            transform: rotate(210deg);
        }

        75% {
            transform: rotate(300deg);
        }

        75% {
            transform: rotate(300deg);
        }

        100% {
            transform: rotate(30deg);
        }
    }

    .loading span {
        width: 1px;
        height: 0.3px;
        position: absolute;
        left: 50%;
        margin-left: -0.5px;
        top: 50%;
        margin-top: 0.3px;
        color: #ff8c00;
        font-size: 0.12px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/loading/loading.vue